<template>
  <!-- <div class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100" id="sidenav-collapse-main"> -->
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="dashboard"
          navText="Dashboard">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="contacts" navText="Contacts">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="pages" navText="Pages">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">pages</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="sections"
          navText="Sections ">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">sections</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="blogs" navText="Blogs">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">blogs</i>
          </template>
        </sidenav-collapse>
      </li>
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="blogDetails"
          navText="Blog Details">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">blog-details</i>
          </template>
        </sidenav-collapse>
      </li> -->


      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="achievements"
          navText="Achievements">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">achievements</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="values" navText="Values">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">values</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="branches" navText="Branches">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">branches</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">
          Citizenship Programs
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipPrograms"
          navText="Programs">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-programs</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipOffers"
          navText="Program Offers">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-offers</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipBenefits"
          navText="Benefits">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-benefits</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="passportBenefits"
          navText="Passport Benefits">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">passport-benefits</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="passport-welcome-countries"
          navText="Passport Welcome Countries" routeName="PassportWelcomeCountries">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">public</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipDetails"
          navText="Details">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-details</i>
          </template>
        </sidenav-collapse>
      </li>



      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipFaqs"
          navText="FAQs">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-faqs</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="investmentOptions"
          navText="Options">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">investment-options</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipCountries"
          navText="Countries">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-countries</i>
          </template>
        </sidenav-collapse>
      </li>


      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipCountryFacts"
          navText="Country Facts">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-country-facts</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipCountryBenefits"
          navText="Country Benefits">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-country-benefits</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="citizenshipCountryProcesses"
          navText="Country Processes">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-country-processess</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false"
          collapseRef="citizenshipCountryRequirements" navText="Country Requirements">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-country-requirements</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="CountryInvestments"
          navText="Country Investments">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">citizenship-country-investments</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">
          Residency programs
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyPrograms"
          navText="Programs">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-programs</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyBenefits"
          navText="Benefits">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-benefits</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyFaqs" navText="FAQ">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-faq</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyCountries"
          navText="Countries">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-countries</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyCountryProcesses"
          navText="Country Processes">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-country-processes</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyCountryFacts"
          navText="Country Facts">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-country-facts</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyCountryBenefits"
          navText="Country Benefits">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-country-benefits</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyCountryFees"
          navText="Country Fees">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-country-fees</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item mb-4">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="residencyCountryRequirements"
          navText="Country Requirements">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">residency-country-requirements</i>
          </template>
        </sidenav-collapse>
      </li>



      <!-- <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder text-white"
          :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">
          Golden Visa
        </h6>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaPrograms"
          navText="Programs">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-programs</i>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaProgramOffers"
          navText="Program Offers">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-program-offers</i>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaBenefits"
          navText="Benefits">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-benefits</i>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaFaqs"
          navText="FAQs">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-faqs</i>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaCountries"
          navText="Countries">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-countries</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaCountryFacts"
          navText="Country Facts">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-country-facts</i>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaCountryBenefits"
          navText="Country Benefits">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-country-benefits</i>
          </template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item mb-4">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="goldenVisaInvestmentOptions"
          navText="Investment Options">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">golden-visa-investment-options</i>
          </template>
        </sidenav-collapse>
      </li> -->
    </ul>

  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavCollapse
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
